import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface EditClientProfileProps extends CacheProps {
  nationalId: string;
  passportNumber: string;
  firstName: string;
  lastName: string;
  sex: string;
  dateOfBirth: string;
  email: string;
  shebaNumber: string
}

const editClientProfile = ({ shebaNumber, passportNumber, dateOfBirth, email, sex, firstName, lastName, nationalId, ...rest }: EditClientProfileProps) => {
  return fetchApi({
    method: 'PUT',
    URL: routes['api.edit.profile'],
    payload: {
      national_id: nationalId,
      passport_number: passportNumber,
      first_name: firstName,
      last_name: lastName,
      sex: sex,
      dob: dateOfBirth,
      email: email,
      sheba_number: shebaNumber,
    },
    withToken: true,
    ...rest,
  });
};

export default editClientProfile;
